/* eslint-disable */

import { Message } from 'element-ui'
import globalMixin from '@/mixin/global'
import Api from '@/repository/index'
const { getUtcFromDate } = globalMixin.methods
const state = {
  data: [],
  latest_id: null
}

const mutations = {
  SET: (state, data) => {
    state.data = data
  },
  REMOVE: (state, id) => {
    state.data = state.data.filter(cur => cur.id !== id)
  },
  ADD: (state, data) => {
    state.data.push(data)
  },
  CHANGE: (state, data) => {
    state.data.forEach(cur => {
      if (cur.id === data.id) {
        cur.id = data.id
        cur.car = data.car
        cur.date = data.date
        cur.description = data.description
        cur.mileage = data.mileage
      }
    })
  },
  SET_ID: (state, id) => {
    if (!id) return
    state.latest_id = id
  }
}

const actions = {

  async fetch ({ commit, state }, id) {
    try {
      commit('SET_ID', id)
      const carId = id || state?.latest_id
      console.log(carId, id, state.latest_id)
      const responce = await Api.parkManager.conditions.getCarConditions({ carId })
      commit('SET', responce)
    } catch (err) {
      return Promise.reject(err)
    }
  },
  async add ({ commit, dispatch }, { id, data }) {
    try {
      console.log({ id, data })
      const responce = await Api.parkManager.conditions.createCarCondition({
        ...data,
        date: getUtcFromDate(data?.date),
        carId: id
      })
      // commit('ADD', responce)
      await dispatch('fetch')
      return responce
    } catch (err) {
      Message({
        message: 'Ошибка',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(err)
    }
  },
  async changeCarCondition ({ commit, dispatch }, { id, data }) {
    try {
      await Api.parkManager.conditions.updateCarCondition({
        ...data,
        date: getUtcFromDate(data?.date),
        conditionId: id
      })
      // commit('CHANGE', responce)
      await dispatch('fetch')
      Message({
        message: 'История состояний была изменена',
        type: 'success',
        duration: 5 * 1000
      })
    } catch (err) {
      Message({
        message: 'Ошибка',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(err)
    }
  },
  async removeCarCondition ({ commit, dispatch }, id) {
    try {
      await Api.parkManager.conditions.deleteCarCondition({
        conditionId: id
      })
      await dispatch('fetch')
      Message({
        message: 'Состояние было стёрто из истории',
        type: 'success',
        duration: 5 * 1000
      })
    } catch (err) {
      Message({
        message: 'Ошибка',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(err)
    }
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
